export default __webpack_public_path__ + "static/media/Email_Tool.79b050a2.svg";